// extracted by mini-css-extract-plugin
export default {"xbutton":"XButton_xbutton__0rVo7","primary":"XButton_primary__9LebA","block":"XButton_block__K4IYX","danger":"XButton_danger__1Xicg","dark":"XButton_dark__lv5BN"};